// Multipart file upload → server-side text extraction. The shared `api` client
// only does JSON, so this calls `fetch` directly (attaching the bearer token
// the same way client.ts does). Mirrors iOS FilesEndpoints.uploadForTextExtraction.

import { API_BASE_URL, API_PREFIX, ApiError } from "./client";
import { tokenStore } from "./token-store";

export interface ExtractTextResponse {
  filename: string;
  file_type: string;
  size_bytes: number;
  extracted_chars: number;
  truncated: boolean;
  text: string;
}

export async function extractTextFromFile(file: File): Promise<ExtractTextResponse> {
  if (file.size === 0) {
    throw new ApiError(422, "That file is empty — try selecting it again.");
  }
  const form = new FormData();
  form.append("file", file, file.name);

  const headers: Record<string, string> = { Accept: "application/json" };
  const token = tokenStore.access;
  if (token) headers.Authorization = `Bearer ${token}`;
  // NOTE: do NOT set Content-Type — the browser sets the multipart boundary.

  const res = await fetch(`${API_BASE_URL}${API_PREFIX}/files/extract-text`, {
    method: "POST",
    headers,
    body: form,
  });

  if (!res.ok) {
    let message = `Upload failed (${res.status})`;
    try {
      const data = await res.json();
      if (typeof data?.detail === "string") message = data.detail;
    } catch {
      /* keep generic */
    }
    throw new ApiError(res.status, message);
  }
  return (await res.json()) as ExtractTextResponse;
}
